import { z } from 'zod';

const grammarSubmittedAnswerSchemaDefinition = z.discriminatedUnion('kind', [
  z.object({ kind: z.literal('option'), index: z.number().int().min(0).max(3) }),
  z.object({ kind: z.literal('text'), text: z.string().max(300) }),
  z.object({ kind: z.literal('order'), tokens: z.array(z.string()).min(1).max(20) }),
  z.object({ kind: z.literal('span'), text: z.string().max(120) }),
]);

export const grammarSubmittedAnswerSchema: typeof grammarSubmittedAnswerSchemaDefinition =
  grammarSubmittedAnswerSchemaDefinition;

export type IGrammarSubmittedAnswer = z.infer<typeof grammarSubmittedAnswerSchema>;
